<template>
  <router-view />
</template>

<script>
export default {
  name: "piecerate",
};
</script>